import { scrollToTop } from '../utils/scrollToTop';

const Footer = () => {
  return (
    <footer className="pt-12 pb-8 px-4 bg-black text-white border-t border-gray-800 transition-colors duration-300">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Left Side - Copyright */}
          <div className="text-center md:text-left text-sm text-gray-400">
            &copy; 2025. All rights reserved.
          </div>

          {/* Right Side - Back to Top */}
          <div className="flex flex-col items-center">
            <button
              onClick={scrollToTop}
              className="bg-transparent border border-gray-600 text-gray-400 px-4 py-2 text-sm transition-all duration-300 hover:bg-white hover:text-black hover:border-white"
            >
              Back to Top
            </button>
          </div>
        </div>

        {/* Bottom Divider */}
        <div className="mt-8 pt-4 border-t border-gray-800 text-center"></div>
      </div>
    </footer>
  );
};

export default Footer;